import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

export const get = async (fleetTaskId) => {
  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/sequence`,
  })

  return response?.data
}

export const getActLoads = async (fleetTaskId) => {
  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/activity-load`,
  })
  
  return response?.data
}

export const update = async (fleetTaskId, pointId, data) => {
  const response = await apiClientV2({
    method: 'PATCH',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/point/${pointId}`,
    data,
  })

  return response?.data
}
